module.exports = __webpack_public_path__ + "assets/img/btn-back-59c7a0bb.png";